import * as React from "react";
import * as ReactDOM from "react-dom";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../mobx/components/index";
import { Tooltip } from "@lib/components";

interface Props {}
interface State {
	modalOpen: boolean;
}

@inject("store")
@observer
export class OrganisationSuspensionBanner extends MobxComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
		};
	}

	openModal = (e?: React.SyntheticEvent) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		this.setState({ modalOpen: true });
	};

	closeModal = (e?: React.SyntheticEvent) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		this.setState({ modalOpen: false });
	};

	renderMessage = (message: string) => {
		const paragraphs = message
			.split(/\n+/)
			.map((part) => part.trim())
			.filter(Boolean);

		if (paragraphs.length === 0) {
			return (
				<p style={{ margin: 0, lineHeight: 1.5, color: "#475569" }}>
					Platform suspended. Please contact the administrator.
				</p>
			);
		}

		return paragraphs.map((paragraph, index) => (
			<p
				key={index}
				style={{
					margin: 0,
					marginBottom: index === paragraphs.length - 1 ? 0 : 12,
					lineHeight: 1.5,
					color: "#475569",
				}}
			>
				{paragraph}
			</p>
		));
	};

	renderModal = () => {
		const suspension = this.injected.store.organisationSuspension;
		if (!this.state.modalOpen || !suspension?.active || typeof document === "undefined") {
			return null;
		}

		return ReactDOM.createPortal(
			<div
				role="dialog"
				aria-modal="true"
				aria-labelledby="organisation-suspension-modal-title"
				onClick={this.closeModal}
				style={{
					position: "fixed",
					inset: 0,
					zIndex: 9000000002,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: 24,
					background: "rgba(15, 23, 42, 0.55)",
				}}
			>
				<div
					onClick={(e) => e.stopPropagation()}
					style={{
						width: "100%",
						maxWidth: 420,
						background: "#fff",
						borderRadius: 8,
						boxShadow: "0 16px 40px rgba(15, 23, 42, 0.25)",
						overflow: "hidden",
					}}
				>
					<div
						style={{
							padding: "20px 24px",
							borderBottom: "1px solid #e5e7eb",
							textAlign: "center",
						}}
					>
						<h3
							id="organisation-suspension-modal-title"
							style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#0f172a" }}
						>
							Limited Access Mode
						</h3>
					</div>
					<div style={{ padding: "20px 24px" }}>
						{this.renderMessage(
							suspension?.admin_message ||
								"Platform suspended. Please contact the administrator."
						)}
					</div>
					<div
						style={{
							padding: "16px 24px",
							borderTop: "1px solid #e5e7eb",
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<button
							type="button"
							onClick={this.closeModal}
							style={{
								background: "#b71c1c",
								border: "none",
								borderRadius: 4,
								color: "#fff",
								cursor: "pointer",
								fontSize: 14,
								fontWeight: 700,
								padding: "10px 18px",
							}}
						>
							Close
						</button>
					</div>
				</div>
			</div>,
			document.body
		);
	};

	render() {
		const { store } = this.injected;
		const suspension = store.organisationSuspension;

		if (!suspension?.active) {
			return null;
		}

		return (
			<>
				<Tooltip text="Click to read more" width={140} position="bottom" offset={6}>
					<button
						type="button"
						onClick={this.openModal}
						title="Click to read more"
						style={{
							background: "#b71c1c",
							border: "1px solid #8f1515",
							borderRadius: 999,
							color: "#fff",
							cursor: "pointer",
							fontSize: 12,
							fontWeight: 700,
							letterSpacing: "0.02em",
							lineHeight: 1,
							padding: "8px 12px",
							whiteSpace: "nowrap",
						}}
					>
						Limited Access
					</button>
				</Tooltip>
				{this.renderModal()}
			</>
		);
	}
}
